import { NameSpacing } from '../../Common/Utils/NameSpacing'

export const NOTIFICATIONS: string = 'settings'
export const UserNotifications: string = 'preferences'

export enum NotificationTabFieldNames {
    ENABLED = 'enabled',
    CME = 'cme',
    TELEPHONY_SERVER = 'telSysID',
    PARTITION = 'partitionIDInTelSys',
    DEVICE_NUMBER = 'deviceNumber',
    CHANNELS = 'channels',
    PHONE_NUMBER = 'telephoneNumber'
}

export enum NotificationUserFiels {
    Name = 'Name',
    NotificationEnabled = 'NotificationEnabled',
    Threshold = 'Threshold'
}

export const NotificationNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(NOTIFICATIONS, fieldName)

export const NotificationUserFieldNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(UserNotifications, fieldName)

export const ENABLED_NAME: string = NotificationNameSpacing(NotificationTabFieldNames.ENABLED)
export const CME_SCOPE_NAME: string = NotificationNameSpacing(NotificationTabFieldNames.CME)
export const TELEPHONY_SERVER_SCOPE_NAME: string = NotificationNameSpacing(NotificationTabFieldNames.TELEPHONY_SERVER)
export const PARTITION_SCOPE_NAME: string = NotificationNameSpacing(NotificationTabFieldNames.PARTITION)
export const DEVICE_SCOPE_NAME: string = NotificationNameSpacing(NotificationTabFieldNames.DEVICE_NUMBER)
export const NOTIFICATION_CHANNEL_NAME: string = NotificationNameSpacing(NotificationTabFieldNames.CHANNELS)
export const NOTIFICATION_PHONE_NUMBER_NAME: string = NotificationNameSpacing(NotificationTabFieldNames.PHONE_NUMBER)
